// Packaging.Packaging — the registry record type.
//
// Per `.docs/v1/design/bounded-contexts.md` §3. Each entry in the
// built-in registry describes one direction of translation between a
// Template endpoint and a Format endpoint (T→F / F→T for MVP; T→T /
// F→F post-MVP), plus the fidelity contract, the implementation
// flavour, the trust level, and the mirror Template for T→F / F→T
// entries.
//
// The four edge categories (T→T / T→F / F→T / F→F) are *derived*
// from the (source, target) pair — a `switch` on the two discriminants
// covers them. No stored discriminant.
//
// The `Packaging` record type sits alongside `Endpoint`, `Trust`, and
// `Flavour` so callers can build entries without pulling five files.
export { mkFlavour, mkPackaging, mkTrust };
const mkTrust = (s) => s;
const mkFlavour = (s) => s;
const mkPackaging = (id, ref, source, target, fidelityContract, mirrorTemplateRef, trust, flavour) => ({
    id,
    ref,
    source,
    target,
    fidelityContract,
    mirrorTemplateRef,
    trust,
    flavour,
});
//# sourceMappingURL=packaging.js.map